import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from "redux-form";
import { Container, Row, Col, } from 'reactstrap';
import { required, acceptAllExceptSingleSpecialCharacter, maxLength80, checkWhiteSpaces, checkSpacesInString, maxLength32, hashValidation, excludeOnlySpecialCharacter } from "../../../helper/validation";
import { renderText, searchableSelect, focusOnError, renderTextInputField, validateForm } from "../../layout/FormInputs";
import {
  createRMSpecificationAPI, updateRMSpecificationAPI, getRMSpecificationDataAPI,
  getRawMaterialNameChild, getMaterialTypeDataAPI, getRMGradeSelectListByRawMaterial,
  getMaterialTypeSelectList, checkAndGetRawMaterialCode
} from '../actions/Material';
import { fetchRMGradeAPI } from '../../../actions/Common';
import Toaster from '../../common/Toaster';
import { MESSAGES } from '../../../config/message';
import { SPECIFICATION } from '../../../config/constants';
import { getConfigurationKey, loggedInUserId } from "../../../helper/auth";
import Drawer from '@material-ui/core/Drawer';
import AddGrade from './AddGrade';
import AddMaterialType from './AddMaterialType';
import AddRawMaterial from './AddRawMaterial';
import { debounce } from 'lodash';
import PopupMsgWrapper from '../../common/PopupMsgWrapper';
import Button from '../../layout/Button';
import TourWrapper from '../../common/Tour/TourWrapper';
import { Steps } from './TourMessages';
import { withTranslation } from 'react-i18next'

class AddSpecification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditFlag: false,
      RawMaterial: [],
      material: [],
      RMGrade: [],
      Id: '',
      isOpenRMDrawer: false,
      isOpenGrade: false,
      isOpenMaterialDrawer: false,
      DropdownChanged: true,
      DataToChange: [],
      setDisable: false,
      rawMaterialId: '',
      rmGradeId: '',
      rmSpecification: '',
      rmCode: '',
      showPopup: false,
      isDropDownChanged: false,
      specificationId: '',
      isRawMaterialNameEditable: true,
      isRawmaterialGradeEditable: true,
    }
  }

  /**
  * @method componentWillMount
  * @description Called before render the component
  */
  UNSAFE_componentWillMount() {
    this.props.getRawMaterialNameChild(() => { })
    // this.props.getMaterialTypeSelectList(() => { })
    this.props.getRMGradeSelectListByRawMaterial('', false, res => { })
  }

  /**
  * @method componentDidMount
  * @description Called after rendering the component
  */
  componentDidMount() {
    const { RawMaterial, RMGrade, isRMDomesticSpec, } = this.props;

    if (isRMDomesticSpec && RawMaterial !== '' && RMGrade !== '') {
      this.props.getRMGradeSelectListByRawMaterial(RawMaterial.value, false, res => { })

      setTimeout(() => {
        const { rawMaterialNameSelectList, gradeSelectList } = this.props;

        let rawMaterialObj = rawMaterialNameSelectList && rawMaterialNameSelectList.find(item => item.Value === RawMaterial.value)
        let rmGradeObj = gradeSelectList && gradeSelectList.find(item => item.Value === RMGrade.value)

        this.setState({
          RawMaterial: rawMaterialObj && rawMaterialObj !== undefined ? { label: rawMaterialObj.Text, value: rawMaterialObj.Value } : [],
          RMGrade: rmGradeObj && rmGradeObj !== undefined ? { label: rmGradeObj.Text, value: rmGradeObj.Value } : [],
        })
      }, 500)
    }

    this.getDetails()

  }

  getDetails = () => {
    const { ID, isEditFlag } = this.props;
    if (isEditFlag) {
      this.props.getRMSpecificationDataAPI(ID, false, res => {
        if (res && res.data && res.data.Data) {
          let Data = res.data.Data;
          this.setState({ DataToChange: Data })
          this.props.getRMGradeSelectListByRawMaterial(Data.RawMaterialId, false, res => { })

          setTimeout(() => {
            const { rawMaterialNameSelectList } = this.props;
            this.props.change('Code', Data?.RawMaterialCode)
            let rawMaterialObj = rawMaterialNameSelectList && rawMaterialNameSelectList.find(item => item.Value === Data.RawMaterialId)
            this.setState({
              RawMaterial: rawMaterialObj && rawMaterialObj !== undefined ? { label: rawMaterialObj.Text, value: rawMaterialObj.Value } : [],
              RMGrade: Data.GradeName !== undefined ? { label: Data.GradeName, value: Data.GradeId } : [],
              specificationId: Data?.SpecificationId,
              isRawMaterialNameEditable: Data.IsRawMaterialNameEditable,
              isRawmaterialGradeEditable: Data.IsRawmaterialGradeEditable
            })
          }, 500)

        }
      });
    } else {
      this.props.getRMSpecificationDataAPI('', false, res => { });
      // if (getConfigurationKey() && getConfigurationKey().IsAutoGeneratedRawMaterialCode && isEditFlag === false) {
      //   this.props.checkAndGetRawMaterialCode('', (res) => {
      //     let Data = res.data.DynamicData;
      //     this.props.change('Code', Data.RawMaterialCode)
      //   })
      // }
    }
  }

  /**
  * @method handleRawMaterial
  * @description  used to raw material change
  */
  handleRawMaterial = (newValue, actionMeta) => {

    if (newValue && newValue !== '') {
      this.setState({ RawMaterial: newValue, RMGrade: [], rawMaterialId: newValue.value, isDropDownChanged: true }, () => {
        const { RawMaterial } = this.state;
        this.props.change('Specification', "")
        this.props.getRMGradeSelectListByRawMaterial(RawMaterial.value, false, res => { });
        if (this.state.rmGradeId && this.state.rmSpecification) {
          let obj = {
            materialNameId: newValue.value,
            materialGradeId: this.state.rmGradeId,
            materialSpec: this.state.rmSpecification,
            materialCode: this.state.rmCode
          }
          this.getRawMaterialCode(obj) //COMMON FUNCTION
        }
      });
    } else {
      this.setState({ RawMaterial: [], RMGrade: [], });
      this.props.getRMGradeSelectListByRawMaterial(0, false, res => { });
    }
  }

  /**
  * @method handleMaterialChange
  * @description  used to material change and get grade's
  */
  handleMaterialChange = (newValue, actionMeta) => {
    if (newValue && newValue !== '') {
      this.setState({ material: newValue }, () => {
        const { material } = this.state;
        this.setDensity(material.value);
      });
    } else {
      this.setState({ material: [], RMGrade: [] });
      this.props.change('Density', '')
    }
  }

  setDensity = (ID) => {
    this.props.getMaterialTypeDataAPI(ID, res => {
      if (res && res.data && res.data.Data) {
        let Data = res.data.Data;
        this.props.change('Density', Data.Density)
      }
    });
  }

  /**
  * @method handleGrade
  * @description  used to handle type of listing change
  */
  handleGrade = (newValue, actionMeta) => {

    if (newValue && newValue !== '') {
      this.setState({ RMGrade: newValue, rmGradeId: newValue.value, isDropDownChanged: true });

      if (this.state.rawMaterialId && this.state.rmSpecification) {
        let obj = {
          materialNameId: newValue.value,
          materialGradeId: this.state.rmGradeId,
          materialSpec: this.state.rmSpecification,
          materialCode: this.state.rmCode
        }
        this.getRawMaterialCode(obj) //COMMON FUNCTION
      }

    } else {
      this.setState({ RMGrade: [], });
    }
    this.setState({ DropdownChanged: false })
  }

  /**
  * @method renderListing
  * @description Used show listing of row material
  */
  renderListing = (label) => {
    const { rawMaterialNameSelectList, MaterialSelectList, gradeSelectList, } = this.props;
    const temp = [];

    if (label === 'RawMaterialName') {
      rawMaterialNameSelectList && rawMaterialNameSelectList.map(item => {
        if (item.Value === '0') return false;
        temp.push({ label: item.Text, value: item.Value })
        return null;
      });
      return temp;
    }

    if (label === 'material') {
      MaterialSelectList && MaterialSelectList.map(item => {
        if (item.Value === '0') return false;
        temp.push({ label: item.Text, value: item.Value })
        return null;
      });
      return temp;
    }

    if (label === 'RMGrade') {
      gradeSelectList && gradeSelectList.map(item => {
        if (item.Value === '0') return false;
        temp.push({ label: item.Text, value: item.Value })
        return null;
      });
      return temp;
    }
  }

  /**
  * @method cancel
  * @description used to Reset form
  */
  cancel = (type) => {
    const { reset } = this.props;
    reset();
    this.setState({
      material: [],
      RMGrade: [],
    })
    this.toggleDrawer('', '', type)
    this.props.getRMSpecificationDataAPI('', false, res => { });
  }

  cancelHandler = () => {
    const { dirty } = this.props;
    if (dirty || this.state.isDropDownChanged) {
      this.setState({ showPopup: true })
    }
    else {
      this.cancel('cancel')
    }
  }
  onPopupConfirm = () => {
    this.cancel('cancel')
    this.setState({ showPopup: false })
  }
  closePopUp = () => {
    this.setState({ showPopup: false })
  }
  toggleDrawer = (event, data, type) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    this.props.closeDrawer('', data, type)
  };

  rawMaterialToggler = (Id = '') => {
    this.setState({ DropdownChanged: false })
    this.setState({ isOpenRMDrawer: true, Id: Id })
  }

  /**
  * @method closeRMDrawer
  * @description  used to toggle RM Drawer Drawer
  */
  closeRMDrawer = (e = '', formData = {}, type) => {
    this.setState({ isOpenRMDrawer: false, Id: '' }, () => {
      if (type === 'submit') {
        this.getDetails()
        this.props.getRawMaterialNameChild(() => {
          this.props.getRMGradeSelectListByRawMaterial('', false, res => { })
          /*FOR SHOWING DEFAULT VALUE FROM SELECTED FROM DRAWER*/
          const { rawMaterialNameSelectList } = this.props;
          if (Object.keys(formData).length > 0) {
            let rawMaterialObj = rawMaterialNameSelectList && rawMaterialNameSelectList.find(item => item.Text === formData.RawMaterialName)
            this.setState({
              RawMaterial: rawMaterialObj && rawMaterialObj !== undefined ? { label: rawMaterialObj.Text, value: rawMaterialObj.Value } : [],
              RMGrade: [],
              rawMaterialId: rawMaterialObj?.Value
            })

          }
        })
      }
    })
  }

  gradeToggler = (Id = '') => {
    this.setState({ DropdownChanged: false })
    this.setState({ isOpenGrade: true, Id: Id })
  }

  /**
  * @method closeGradeDrawer
  * @description  used to toggle grade Drawer
  */
  closeGradeDrawer = (e = '', formData = {}, type) => {
    this.setState({ isOpenGrade: false, Id: '' }, () => {
      if (type === 'submit') {
        this.getDetails()
        const { RawMaterial } = this.state;
        this.props.getRMGradeSelectListByRawMaterial(RawMaterial.value, false, res => {
          /* FOR SHOWING DEFAULT VALUE SELECTED FROM DRAWER*/
          const { gradeSelectList } = this.props;
          let rmGradeObj = null;
          if (Object.keys(formData).length > 0) {
            if (gradeSelectList && gradeSelectList.length > 0) {
              rmGradeObj = gradeSelectList.find(item => item.Text.split('(')[0].trim() === formData.Grade);
            }
            this.setState({
              RMGrade: rmGradeObj && rmGradeObj !== undefined ? { label: rmGradeObj.Text, value: rmGradeObj.Value } : [],
              rmGradeId: rmGradeObj?.Value
            })

            if (this.state.rawMaterialId && this.state.rmSpecification) {
              let obj = {
                materialNameId: this.state.rawMaterialId,
                materialGradeId: rmGradeObj?.Value,
                materialSpec: this.state.rmSpecification,
                materialCode: this.state.rmCode
              }
              this.getRawMaterialCode(obj) //COMMON FUNCTION
            }
          }
        });
      }
    })
  }

  materialToggler = () => {
    this.setState({ isOpenMaterialDrawer: true })
  }


  /**
  * @method closeMaterialDrawer
  * @description  used to toggle Material Drawer
  */
  closeMaterialDrawer = (e = '', formData = {}) => {
    this.setState({ isOpenMaterialDrawer: false }, () => {
      this.props.getMaterialTypeSelectList(() => {
        /*THIS IS FOR SELECTING DEFAULT VALUE OF MATERIAL  FROM DRAWER*/
        const { MaterialSelectList } = this.props;
        if (Object.keys(formData).length > 0) {
          let materialTypeObj = MaterialSelectList && MaterialSelectList.find(item => item.Text === formData.MaterialType)
          this.setState({
            material: materialTypeObj && materialTypeObj !== undefined ? { label: materialTypeObj.Text, value: materialTypeObj.Value } : [],
          })
          this.props.change('Density', formData.CalculatedDensityValue)
        }
      })
    })
  }

  /**
  * @method onSubmit
  * @description Used to Submit the form
  */
  onSubmit = debounce((values) => {
    const { RawMaterial, material, RMGrade, DataToChange, DropdownChanged } = this.state;
    const { ID, isEditFlag } = this.props;

    if (isEditFlag) {
      if (DataToChange.Specification === values.Specification && DropdownChanged) {
        this.cancel('cancel')
        return false
      }
      this.setState({ setDisable: true })
      let formData = {
        RawMaterialId: RawMaterial.value,
        SpecificationId: ID,
        Specification: values.Specification,
        GradeId: RMGrade.value,
        IsActive: true,
        CreatedDate: '',
        CreatedBy: loggedInUserId(),
        GradeName: RMGrade.label,
        MaterialId: material.value,
        MaterialTypeName: material.label,
        RawMaterialCode: values.Code
      }

      this.props.updateRMSpecificationAPI(formData, (res) => {
        this.setState({ setDisable: false })
        if (res?.data?.Result) {
          Toaster.success(MESSAGES.SPECIFICATION_UPDATE_SUCCESS);
          this.toggleDrawer('', '', 'submit')
        }
      })
    } else {

      this.setState({ setDisable: true })
      let formData = {
        RawMaterialId: RawMaterial.value,
        Specification: values.Specification,
        GradeId: RMGrade.value,
        MaterialId: material.value,
        RawMaterialCode: values.Code
      }

      this.props.createRMSpecificationAPI(formData, (res) => {
        this.setState({ setDisable: false })
        if (res?.data?.Result) {
          Toaster.success(MESSAGES.SPECIFICATION_ADD_SUCCESS);
          this.toggleDrawer('', formData, 'submit')
        }
      });
    }
  }, 500)

  handleKeyDown = function (e) {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
    }
  };

  checkUniqCode = debounce((e) => {
    this.setState({ rmCode: e.target.value })
    let obj = {
      materialNameId: this.state.rawMaterialId,
      materialGradeId: this.state.rmGradeId,
      materialSpec: this.state.rmSpecification,
      materialCode: e.target.value
    }
    this.props.checkAndGetRawMaterialCode(obj, res => {
      if (res && res.data && res.data.Result === false) {
        Toaster.warning(res.data.Message);
        this.props.change('Code', "")
      } else {
        let Data = res.data.Identity;
        this.props.change('Code', Data)
      }
    })
  }, 600)


  onSpecificationChange = debounce((e) => {
    this.setState({ rmSpecification: e.target.value })
    if (this.state.rawMaterialId && this.state.rmGradeId) {
      let obj = {
        materialNameId: this.state.rawMaterialId,
        materialGradeId: this.state.rmGradeId,
        materialSpec: e.target.value,
        materialCode: this.state.rmCode
      }
      this.getRawMaterialCode(obj) //COMMON FUNCTION

    }
  }, 600)


  getRawMaterialCode = (obj) => {
    this.props.checkAndGetRawMaterialCode(obj, (res) => {
      let Data = res.data.Identity;
      this.props.change('Code', Data)
    })

  }

  /**
  * @method render
  * @description Renders the component
  */
  render() {
    const { isOpenRMDrawer, isOpenGrade, isOpenMaterialDrawer, setDisable } = this.state;
    const { handleSubmit, isEditFlag, specificationData, AddAccessibilityRMANDGRADE,
      EditAccessibilityRMANDGRADE, t, isAssociate } = this.props;
    return (
      <div>
        <Drawer
          anchor={this.props.anchor}
          open={this.props.isOpen}
        // onClose={(e) => this.toggleDrawer(e)}
        >
          <Container>
            <div className={"drawer-wrapper spec-drawer"}>
              <form
                noValidate
                className="form"
                onSubmit={handleSubmit(this.onSubmit.bind(this))}
                onKeyDown={(e) => { this.handleKeyDown(e, this.onSubmit.bind(this)); }}
              >
                <Row className="drawer-heading">
                  <Col>
                    <div className={"header-wrapper left"}>
                      <h3>
                        {isEditFlag
                          ? "Update  Specification"
                          : "Add Raw Material Specification"}
                        <TourWrapper
                          buttonSpecificProp={{ id: "Add_RM_Spec_Form" }}
                          stepsSpecificProp={{
                            steps: Steps(t, { isEditFlag: isEditFlag }).ADD_RAW_MATERIAL_SPEC
                          }} />
                      </h3>
                    </div>
                    <div
                      onClick={(e) => this.toggleDrawer(e)}
                      className={"close-button right"}
                    ></div>
                  </Col>
                </Row>
                <div className="ml-3">
                  <Row>
                    <Col md="12">
                      <div className="d-flex">
                        <Field
                          name="RawMaterialName"
                          type="text"
                          label="Raw Material"
                          component={searchableSelect}
                          placeholder={"Select"}
                          options={this.renderListing("RawMaterialName")}
                          //onKeyUp={(e) => this.changeItemDesc(e)}
                          validate={
                            this.state.RawMaterial == null || this.state.RawMaterial.length === 0 ? [required] : []}
                          required={true}
                          handleChangeDescription={this.handleRawMaterial}
                          valueDescription={this.state.RawMaterial}
                          disabled={isEditFlag && !this.state.isRawMaterialNameEditable ? true : false}
                          className="w-100"
                        />

                        {isEditFlag
                          ? EditAccessibilityRMANDGRADE && (
                            <Button
                              id="RawMaterialName-edit"
                              className="drawer-edit mt30"
                              variant="Edit"
                              onClick={() => this.rawMaterialToggler(specificationData.RawMaterialId)}
                              disabled={!this.state.isRawMaterialNameEditable}
                            />
                          )
                          : AddAccessibilityRMANDGRADE && (
                            <Button
                              id="RawMaterialName-add"
                              className="mt40 right"
                              variant="plus-icon-square"
                              onClick={() => this.rawMaterialToggler("")}
                            />
                          )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <div className="d-flex justify-space-between align-items-center inputwith-icon">
                        <div className="fullinput-icon">
                          <Field
                            name="GradeId"
                            type="text"
                            label="Grade"
                            component={searchableSelect}
                            placeholder={"Select"}
                            options={this.renderListing("RMGrade")}
                            //onKeyUp={(e) => this.changeItemDesc(e)}
                            validate={
                              this.state.RMGrade == null || this.state.RMGrade.length === 0 ? [required] : []}
                            required={true}
                            handleChangeDescription={this.handleGrade}
                            valueDescription={this.state.RMGrade}
                            disabled={isEditFlag && !this.state.isRawmaterialGradeEditable ? true : false}
                          />
                        </div>
                        {isEditFlag ? (
                          EditAccessibilityRMANDGRADE && (
                            <Button
                              id="GradeId-edit"
                              className="drawer-edit mt-2"
                              variant="Edit"
                              onClick={() => this.gradeToggler(specificationData.GradeId)}
                              disabled={!this.state.isRawmaterialGradeEditable}
                            />
                          )
                        ) :
                          AddAccessibilityRMANDGRADE &&
                          <Button
                            id="GradeId-add"
                            className="mt-2"
                            variant={`${this.state.RawMaterial == null || this.state.RawMaterial.length === 0 ? "blurPlus-icon-square" : "plus-icon-square"}`}
                            onClick={() => this.gradeToggler("")}
                          />
                        }
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    {/* <Col md="12">
                      <div className="d-flex">
                        <Field
                          name="MaterialTypeId"
                          type="text"
                          label="Material"
                          component={searchableSelect}
                          placeholder={"Select"}
                          options={this.renderListing("material")}
                          //onKeyUp={(e) => this.changeItemDesc(e)}
                          validate={this.state.material == null || this.state.material.length === 0 ? [required] : []} required={true}
                          handleChangeDescription={this.handleMaterialChange}
                          valueDescription={this.state.material}
                        />

                        <div
                          onClick={this.materialToggler}
                          className={"plus-icon-square mt30  right"}
                        ></div>
                      </div>
                    </Col> */}
                    {/* <Col md="12">
                      <Field
                        label={`Density`}
                        name={"Density"}
                        type="text"
                        placeholder={"Enter"}
                        validate={[required]}
                        component={renderText}
                        // required={true}
                        className=" "
                        disabled={true}
                        customClassName=" withBorder"
                      />
                    </Col> */}
                  </Row>


                  <Row>
                    <Col md="12">
                      <Field
                        label={`${SPECIFICATION}`}
                        name={"Specification"}
                        type="text"
                        placeholder={"Enter"}
                        validate={[required, acceptAllExceptSingleSpecialCharacter, maxLength80, checkWhiteSpaces, hashValidation]}
                        component={renderTextInputField}
                        required={true}
                        onChange={getConfigurationKey()?.IsAutoGeneratedRawMaterialCode ? this.onSpecificationChange : () => { }}
                        className=" "
                        customClassName=" withBorder"
                        disabled={isEditFlag && isAssociate ? true : false}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <Field
                        label={`Code`}
                        name={'Code'}
                        type="text"
                        placeholder={'Enter'}
                        validate={[required, excludeOnlySpecialCharacter, checkSpacesInString, checkWhiteSpaces, maxLength32]}
                        component={renderText}
                        required={true}
                        className=" "
                        customClassName=" withBorder"
                        //onBlur={this.checkUniqCode}
                        onChange={getConfigurationKey()?.IsAutoGeneratedRawMaterialCode ? this.checkUniqCode : () => { }}
                        disabled={(isEditFlag || getConfigurationKey()?.IsAutoGeneratedRawMaterialCode) ? true : false}
                      />
                    </Col>
                  </Row>

                  <Row className="sf-btn-footer no-gutters justify-content-between">
                    <div className="col-md-12 pr-3">
                      <div className="text-right ">
                        <Button
                          id="rm-specification-cancel"
                          className="mr-2"
                          variant={"cancel-btn"}
                          disabled={setDisable}
                          onClick={this.cancelHandler}
                          icon={"cancel-icon"}
                          buttonName={"Cancel"}
                        />
                        <Button
                          id="rm-specification-submit"
                          type="submit"
                          className="save-btn"
                          disabled={setDisable}
                          icon={"save-icon"}
                          buttonName={isEditFlag ? "Update" : "Save"}
                        />
                      </div>
                    </div>
                  </Row>
                </div>
              </form>
            </div>
          </Container>
        </Drawer>
        {
          this.state.showPopup && <PopupMsgWrapper isOpen={this.state.showPopup} closePopUp={this.closePopUp} confirmPopup={this.onPopupConfirm} message={`${MESSAGES.CANCEL_MASTER_ALERT}`} />
        }
        {isOpenRMDrawer && (
          <AddRawMaterial
            isOpen={isOpenRMDrawer}
            closeDrawer={this.closeRMDrawer}
            isEditFlag={isEditFlag}
            ID={this.state.Id}
            anchor={"right"}
          />
        )}
        {isOpenGrade && (
          <AddGrade
            isOpen={isOpenGrade}
            closeDrawer={this.closeGradeDrawer}
            isEditFlag={isEditFlag}
            RawMaterial={this.state.RawMaterial}
            ID={this.state.Id}
            anchor={"right"}
            specificationId={this.state.specificationId}
          />
        )}
        {isOpenMaterialDrawer && (
          <AddMaterialType
            isOpen={isOpenMaterialDrawer}
            closeDrawer={this.closeMaterialDrawer}
            isEditFlag={isEditFlag}
            //ID={ID}
            anchor={"right"}
          />
        )}
      </div>
    );
  }
}

/**
* @method mapStateToProps
* @description return state to component as props
* @param {*} state
*/
function mapStateToProps({ comman, material }) {
  const { specificationData, rawMaterialNameSelectList, gradeSelectList, MaterialSelectList } = material;

  let initialValues = {};
  if (specificationData && specificationData !== undefined) {
    initialValues = { Specification: specificationData.Specification, }
  }

  return {
    gradeSelectList, MaterialSelectList, specificationData,
    rawMaterialNameSelectList, initialValues
  }
}

/**
 * @method connect
 * @description connect with redux
 * @param {function} mapStateToProps
 * @param {function} mapDispatchToProps
 */
export default connect(mapStateToProps, {
  createRMSpecificationAPI,
  fetchRMGradeAPI,
  getMaterialTypeSelectList,
  updateRMSpecificationAPI,
  getRMSpecificationDataAPI,
  getRawMaterialNameChild,
  getMaterialTypeDataAPI,
  getRMGradeSelectListByRawMaterial,
  checkAndGetRawMaterialCode
})(reduxForm({
  form: 'AddSpecification',
  enableReinitialize: true,
  validate: validateForm,
  touchOnChange: true,
  onSubmitFail: (errors) => {
    focusOnError(errors)
  },
})(withTranslation(['RawMaterialMaster'])(AddSpecification)),

)
